//import logo from './logo.svg';
import './App.css';
//Data Components
import Database from "./components/Database.js";

//View Components
import Navigation from './components/Navigation.js';
import Gallery from './components/Gallery.js';
import Login from './components/Login.js';
import Table from './components/Table.js';
import Profile from './components/Profile.js';

//Data Layer
const students = Database.students;
const books = Database.books;
const authors = Database.authors;
const contributors=Database.contributors;

function App() {

  return (
    <div className="App">
      <Navigation />
      <main className='container-fluid'>
        <section>
          <h1>Top Books</h1>
          <Gallery books={books} />
        </section>
        <section>
          <h1>Top Authors</h1>
          <Gallery authors={authors} />
        </section>
        <section>
          <h1>Top Contributers</h1>
          <Gallery profiles={contributors} />
        </section>
        <Profile test={students}/>
        <Login />
        <Table />
      </main>
      <footer>Hariharan Umapathi &copy; 2021</footer>
    </div>
  );
}


export default App;
